import React, { useCallback, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Divider,
  Box,
  InputAdornment
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { CurrentState } from "../ForgotPassword";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "80px",
    paddingBottom: "80px"
  },
  forgotContainer: {
    padding: theme.spacing(5),
    [theme.breakpoints.up("xs")]: {
      minWidth: "80%",
      maxWidth: "90%"
    },
    [theme.breakpoints.up("md")]: {
      minWidth: "60%",
      maxWidth: "70%"
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: "40%",
      maxWidth: "50%"
    }
  },
  forgotTitle: {
    fontWeight: "bold"
  },
  DividerContainer: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  DividerBar: {
    height: "2px",
    margin: "auto",
    width: "50%",
    backgroundColor: theme.palette.kpYellowColors.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submitButtonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2)
  },
  submitButton: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(1.2),
    paddingBottom: theme.spacing(1.2)
  }
}));

function ForgotConfirm({ setCurrentState, setValues, values }) {
  const {
    root,
    form,
    forgotContainer,
    forgotTitle,
    DividerContainer,
    DividerBar,
    submitButtonContainer,
    submitButton
  } = useStyles();

  const [active, setToggleActive] = useState(true);

  const handleChange = useCallback(
    (e) => {
      setValues({
        ...values,
        [e.target.name]: e.target.value
      });
    },
    [values, setValues]
  );

  const handleSubmit = useCallback(() => {
    setToggleActive(false);
    setCurrentState(CurrentState.RESET);
    return false;
  }, [setCurrentState]);

  return (
    <Grid className={root} container justifyContent="center" alignItems="center">
      <Paper className={forgotContainer}>
        <Typography
          className={forgotTitle}
          align="center"
          variant="h5"
          color="primary"
        >
          Confirmation Code
        </Typography>
        <Box className={DividerContainer}>
          <Divider className={DividerBar} />
        </Box>
        <Typography variant="subtitle1" align="center">
          A <b>confirmation code</b> was sent to your email. Please enter that
          code here.
        </Typography>
        <form className={form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="confirmation"
            label="Confirmation Code"
            name="confirmation"
            autoComplete="name"
            autoFocus
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              )
            }}
          />
          <Grid container className={submitButtonContainer}>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={submitButton}
                onClick={handleSubmit}
                disabled={!active || !values["confirmation"]}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Grid>
  );
}

export default ForgotConfirm;
